import PropTypes from 'prop-types';
import React from 'react';

import CompactText from 'modules/Common/components/CompactText';

require("./FootballMatchOutcomeDescription.scss");

function hasWinner(outcome, winnerName, resultType) {
  return outcome === 'WIN' && winnerName && resultType;
}

function generateWinnerComponent(winnerName, winnerShortName, enableCompactText) {
  return enableCompactText ? (<CompactText compactText={winnerShortName}>{winnerName}</CompactText>) : winnerName;
}

function generatePenaltyShootoutWinnerComponent(winnerName, winnerShortName, homePenaltyShootoutScore, awayPenaltyShootoutScore, enableCompactText, style) {
  if (homePenaltyShootoutScore === undefined || awayPenaltyShootoutScore === undefined) {
    return null;
  }

  let scorelineText;
  if (homePenaltyShootoutScore > awayPenaltyShootoutScore) {
    scorelineText = `${homePenaltyShootoutScore}-${awayPenaltyShootoutScore}`;
  } else {
    scorelineText = `${awayPenaltyShootoutScore}-${homePenaltyShootoutScore}`;
  }

  return (
    <div className={"outcome-description " + style}>{generateWinnerComponent(winnerName, winnerShortName, enableCompactText)} win {scorelineText} on penalties</div>
  );
}

function generateAwayGoalsWinnerComponent(winnerName, winnerShortName, enableCompactText, style) {
  return (
    <div className={"outcome-description " + style}>{generateWinnerComponent(winnerName, winnerShortName, enableCompactText)} win on away goals</div>
  );
}

export default function FootballMatchOutcomeDescription({
  matchOutcome: {
    outcome: outcome,
    result_type: resultType,
    winner: {
      name: winnerName,
      short_name: winnerShortName
    } = {}
  } = {},
  penaltyShootoutScore: {
    home: homePenaltyShootoutScore,
    away: awayPenaltyShootoutScore
  } = {},
  enableCompactText = true,
  style = "match-results"
} = {}) {
  if (hasWinner(outcome, winnerName, resultType)) {
    switch (resultType) {
      case "PENALTYSHOOTOUT" :
        return generatePenaltyShootoutWinnerComponent(winnerName, winnerShortName, homePenaltyShootoutScore, awayPenaltyShootoutScore, enableCompactText, style);
      case "AWAYGOALS" :
        return generateAwayGoalsWinnerComponent(winnerName, winnerShortName, enableCompactText, style);
      default :
        return null;
      }
  }

  return null;
}

FootballMatchOutcomeDescription.propTypes = {
  matchOutcome: PropTypes.shape({
    outcome: PropTypes.string,
    result_type: PropTypes.string,
    winner: PropTypes.shape({
      name: PropTypes.string,
      short_name: PropTypes.string
    })
  }),
  penaltyShootoutScore: PropTypes.shape({
    home: PropTypes.number,
    away: PropTypes.number
  }),
  enableCompactText: PropTypes.bool,
  style: PropTypes.string
};




// WEBPACK FOOTER //
// ./modules/Football/components/FootballMatchOutcomeDescription.js